import React, { useState, useEffect, useRef } from "react";
import {
  DavidImg,
  DonnyImg,
  ClarenceImg,
  TroyImg,
  PatriciaImg,
  JordanImg,
  DanielImg,
} from "../assets/team";

const teamArray = [
  {
    name: "David Serabian",
    title: "Chief Executive Officer",
    link: "https://www.linkedin.com/in/david-serabian/",
    img: DavidImg,
    blurb: "David has been a research consultant for a Fortune 500 CEO family office, and a US Presidential Cybersecurity Commission. With the commission his policy recommendations were included to the President. He previously founded a fintech startup as a CCO. David has a passion for developing organizations and being a servant leader.",
  },
  {
    name: "Donny Vallejo",
    title: "Chief Operating Officer",
    link: "https://www.linkedin.com/in/donaldvallejo/",
    img: DonnyImg,
    blurb: "Donny is our COO. He is a skilled software developer Who has experience scaling a software startup. He Taught classes at UC Berkeley and Is incredible at building teams.",
  },
  {
    name: "Clarence Cheung",
    title: "Software Engineer",
    link: "https://www.linkedin.com/in/clarence-cheung-887460165/",
    img: ClarenceImg,
    blurb: "Clarence is a Software engineer and he has a pragmatic approach to problem solving, incredible drive, and tireless work ethic.",
  },
  {
    name: "Troy Grossi",
    title: "Software Engineer",
    link: "https://www.linkedin.com/in/troy-grossi/",
    img: TroyImg,
    blurb: "Troy is a full-stack software engineer who focus on building scalable and maintainable applications. He has a degree in CS and attended classes at UC berkeley. He was an Eagle Scout, a former varsity wrestler, and a rugby player.",
  },
  // {
  //   name: "Patricia Mangiagli",
  //   title: "Strategic Advisor",
  //   link: "https://www.linkedin.com/in/patriciamangiagli/",
  //   img: PatriciaImg,
  //   blurb: "Patricia is a strategic advisor with extensive experience in business development and organizational leadership. She brings valuable insights in scaling operations and building strategic partnerships that drive sustainable growth.",
  // },
  {
    name: "Jordan Kanchanda",
    title: "Cybersecurity Specialist",
    link: "https://www.linkedin.com/in/jordan-kanchanda/",
    img: JordanImg,
    blurb: "Jordan is a cybersecurity specialist with expertise in threat analysis and security infrastructure. He brings deep knowledge in cybersecurity protocols and risk assessment, ensuring our platform maintains the highest security standards for our users.",
  },
  {
    name: "Daniel Huffman",
    title: "Finance & Accounting",
    link: "https://www.linkedin.com/in/danielhuffman/",
    img: DanielImg,
    blurb: "Daniel is our finance and accounting specialist who ensures Valiant's financial health and strategic growth. He brings expertise in financial planning, budgeting, and accounting practices that keep our operations running smoothly and sustainably.",
  },
]

const TeamCard = ({ name="Name", title="Engineer", link="#", blurb="say something nice", img="", index, delay }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Only trigger once
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(cardRef.current);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px',
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  const animationStyles = {
    transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.95)',
    opacity: isVisible ? 1 : 0,
    transition: `transform 0.6s ease-out ${delay}ms, opacity 0.6s ease-out ${delay}ms`,
  };

  return (
    <div 
      ref={cardRef}
      className="relative overflow-hidden rounded-lg bg-white bg-opacity-90 shadow-xl border border-gray-200"
      style={animationStyles}
    >
      <div className="absolute inset-0 bg-grid-white/[0.1] bg-[length:16px_16px]"></div>
      
      <div className="flex flex-col md:flex-row">
        {/* Image and name section */}
        <div className="p-4 md:p-4 sm:p-3 text-center md:text-left md:w-1/3 sm:w-full bg-gray-100 bg-opacity-50">
          <div className={`relative mx-auto md:mx-0 h-44 md:h-36 sm:h-28 w-44 md:w-36 sm:w-28 overflow-hidden rounded-full border-4 border-gray-200 shadow-lg mb-4 md:mb-3 sm:mb-2 group transition-all duration-700 ${isVisible ? "animate-pulse-once" : ""}`}>
            <img 
              className={`h-full w-full object-cover transition-all duration-700 ${isVisible ? "scale-100" : "scale-95"}`}
              src={img} 
              alt={name}
              style={{ transition: `transform 1.2s ease-out ${delay + 300}ms` }}
            />
            
            {/* Glow effect behind image */}
            <div className={`absolute -inset-1 rounded-full blur-xl bg-gray-200 -z-10 transition-all duration-700 ${isVisible ? "bg-gray-300 opacity-100" : "opacity-0"}`}
                 style={{ transition: `opacity 1s ease-out ${delay + 500}ms, background-color 1s ease-out ${delay + 500}ms` }}></div>
          </div>
          
          <h3 className={`text-2xl md:text-xl sm:text-lg font-bold text-gray-800 mb-1 transition-all duration-500 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}
              style={{ transition: `transform 0.5s ease-out ${delay + 200}ms, opacity 0.5s ease-out ${delay + 200}ms` }}>
            {name}
          </h3>
          <p className={`text-lg md:text-base sm:text-sm text-gray-600 mb-3 md:mb-2 sm:mb-1 transition-all duration-500 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}
             style={{ transition: `transform 0.5s ease-out ${delay + 300}ms, opacity 0.5s ease-out ${delay + 300}ms` }}>
            {title}
          </p>
          
          <a 
            href={link}
            target="_blank" 
            rel="noopener noreferrer"
            className={`relative z-10 inline-block py-1 px-4 md:py-1 md:px-3 sm:py-1 sm:px-2 text-gray-800 bg-transparent border-[2.5px] border-gray-800 rounded-md hover:bg-gray-800 hover:text-white transition-all duration-300 text-base sm:text-sm cursor-pointer`}
            onClick={(e) => {
              console.log("Button clicked, link:", link);
              if (!link || link === "#") {
                e.preventDefault();
                console.log("No valid link provided");
              }
            }}
          >
            Connect
          </a>
        </div>
        
        {/* Description section */}
        <div className={`p-4 md:p-4 sm:p-3 md:w-2/3 bg-white flex flex-col justify-center transition-all duration-500 hover:bg-gray-50 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0"}`}
             style={{ transition: `transform 0.7s ease-out ${delay + 200}ms, opacity 0.7s ease-out ${delay + 200}ms` }}>
          <p className="text-gray-700 leading-relaxed text-lg md:text-base sm:text-sm">
            {blurb}
          </p>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className={`absolute top-4 right-4 h-20 w-20 md:h-16 md:w-16 sm:h-12 sm:w-12 rounded-full bg-gray-200/40 blur-xl transition-all duration-700 ${isVisible ? "scale-100 opacity-100" : "scale-0 opacity-0"}`}
           style={{ transition: `transform 1s ease-out ${delay + 600}ms, opacity 1s ease-out ${delay + 600}ms` }}></div>
      <div className={`absolute bottom-4 left-4 h-16 w-16 md:h-12 md:w-12 sm:h-10 sm:w-10 rounded-full bg-gray-200/40 blur-xl transition-all duration-700 ${isVisible ? "scale-100 opacity-100" : "scale-0 opacity-0"}`}
           style={{ transition: `transform 1s ease-out ${delay + 700}ms, opacity 1s ease-out ${delay + 700}ms` }}></div>
    </div>
  );
}

export const Team = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const titleStyles = {
    transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(-30px) scale(0.95)',
    opacity: isVisible ? 1 : 0,
    transition: 'transform 0.8s ease-out, opacity 0.8s ease-out',
  };

  const subtitleStyles = {
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    opacity: isVisible ? 1 : 0,
    transition: 'transform 0.8s ease-out 200ms, opacity 0.8s ease-out 200ms',
  };

  return (
    <div 
      className="w-full relative py-6 md:py-4 sm:py-2"
      style={{ 
        backgroundImage: 'url("/escheresque.webp")',
        backgroundRepeat: 'repeat',
        backgroundSize: '150px'
      }}
    >
      <div ref={sectionRef} name="team" className="w-full">
        {/* Section header */}
        <div className="container mx-auto px-6 md:px-4 sm:px-3 mb-10 md:mb-6 sm:mb-4 pt-8 md:pt-6 sm:pt-4">
          <h2 
            className="text-5xl md:text-4xl sm:text-3xl font-bold text-center text-black py-3 md:py-2 sm:py-2 my-6 md:my-4 sm:my-3"
            style={titleStyles}
          >
            Our Team
          </h2>
          <p 
            className="text-xl md:text-lg sm:text-base text-black text-center max-w-3xl mx-auto mt-3 md:mt-2 sm:mt-1"
            style={subtitleStyles}
          >
            The innovative minds behind Valiant working to transform AI research workflows
          </p>
        </div>
        
        {/* Team grid */}
        <div className="container mx-auto px-6 md:px-4 sm:px-3 pb-10 md:pb-8">
          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-3">
            {teamArray.map((member, index) => (
              <TeamCard 
                key={`tm_${index}`}
                name={member.name}
                title={member.title}
                link={member.link}
                blurb={member.blurb}
                img={member.img}
                index={index}
                delay={index * 200}  // Staggered animation delay
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}